type IsAny<T> = 0 extends (1 & T) ? true : false;
type DefinedProperties<T> = {
  [K in keyof T as IsAny<T[K]> extends true ? K : undefined extends T[K] ? never : K]: T[K];
} & {
  [K in keyof T as IsAny<T[K]> extends true ? never : undefined extends T[K] ? K : never]?: Exclude<T[K], undefined>;
};

/** Omit absent top-level values when constructing config/IPC objects. Keeps {}, false and null. */
export function omitUndefined<T extends object>(value: T): DefinedProperties<T> {
  return Object.fromEntries(
    Object.entries(value).filter(([, entry]) => entry !== undefined)
  ) as DefinedProperties<T>;
}
